import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alert, Card, Descriptions, Flex, Table, Typography } from "antd";
import { useState, useEffect } from 'react';
import SubProjectHoldReasonInfo from "./SubProjectHoldReasonInfoModal";
import { formatDisplayDate } from "../../utils/commonUtil";
import { getLstProductFamilyForProject, getLstRiskReason, getWoCertificates } from "../../services/projectService";
import SubProjectRiskStatusInfoModal from "./SubProjectRiskStatusInfoModal";
import SubProjectProductFamilyModal from "./SubProjectProductFamilyModal";
import SubProjectCertificateModal from "./SubProjectCertificateModal";
import certificate_down from '../../assets/images/certificate_down.png';
const SubProjectDataTable = ({ lstWorkOrder, projectId }) => {
    const [tableData, setTableData] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenRiskStatus, setIsModalOpenRiskStatus] = useState(false);
    const [isModalOpenProductFamily, setIsModalOpenProductFamily] = useState(false);
    const [isModalOpenCertificate, setIsModalOpenCertificate] = useState(false);
    const [listOfHoldReason, setListOfHoldReason] = useState();
    const [listOfRiskStatus, setListOfRiskStatus] = useState();
    const [listOfProductFamily, setListOfProductFamily] = useState();
    const [listOfVendorCertificates, setListOfVendorCertificates] = useState();
    const [holdReasonTitleKeyword, setHoldReasonTitleKeyword] = useState("");
    const [woCertificatesTitleKeyword, setWoCertificatesTitleKeyword] = useState("");
    const handleOpenSubProjectHoldReasonInfoModal = (lstOfHoldReason) => {
        setIsModalOpen(true);
        setListOfHoldReason(lstOfHoldReason);
    };
    const handleOpenSubProjectRiskStatusInfoModal = (workOrderId) => {
        getLstRiskReasonFun(workOrderId);
        setIsModalOpenRiskStatus(true);
    };
    const handleOpenProductFamilyModal = () => {
        //setListOfProductFamily(listOfProductFamily);
        setIsModalOpenProductFamily(true);
        getListOfProductFamily();
    };
    const handleOpenWOCertificatesModal = (workOrderId) => {
        getListOfVendorCertificates(workOrderId);
        setIsModalOpenCertificate(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleOkRS = () => {
        setIsModalOpenRiskStatus(false);
    };
    const handleOkPF = () => {
        setIsModalOpenProductFamily(false);
    };
    const handleOkCertificate = () => {
        setIsModalOpenCertificate(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const handleCancelRS = () => {
        setIsModalOpenRiskStatus(false);
    };
    const handleCancelPF = () => {
        setIsModalOpenProductFamily(false);
    };
    const handleCancelCertificate = () => {
        setIsModalOpenCertificate(false);
    };
    function getLstRiskReasonFun(workOrderId) {
        getLstRiskReason(workOrderId).then((responseData) => {
            setListOfRiskStatus(responseData);
        });
    }
    function getListOfVendorCertificates(workOrderId) {
        getWoCertificates(workOrderId).then((responseData) => {
            setListOfVendorCertificates(responseData);
        });
    }
    function getListOfProductFamily() {
        getLstProductFamilyForProject(projectId).then((responseData) => {
            setListOfProductFamily(responseData);
        });
    }
    const columns = [
        {
            title: 'Certificate',
            dataIndex: 'certificate',
            key: 'certificate',
            render: (text, params) => (_jsxs(Flex, { children: [(params === null || params === void 0 ? void 0 : params.isCertificateAvailable)
                        &&
                            _jsx("img", { src: certificate_down, alt: "Cert", style: { textAlign: 'center', width: '25px', height: '25px', cursor: 'pointer' }, onClick: (e) => {
                                    handleOpenWOCertificatesModal(params === null || params === void 0 ? void 0 : params.workOrderId);
                                    setWoCertificatesTitleKeyword('Download Certificate - ' + (params === null || params === void 0 ? void 0 : params.certificate));
                                }, title: "Download Certificates" }), _jsx(Typography.Text, { children: params.certificate })] }))
        },
        {
            title: 'Country /Territory',
            dataIndex: 'country',
            key: 'country',
        },
        {
            title: 'Sub Project Status',
            dataIndex: 'subProjectStatus',
            key: 'subProjectStatus',
            render: (text, params) => ((params.subProjectStatusId != 4004 && params.subProjectStatusId != 4005)
                ? _jsx(Typography.Text, { color: `${params.styleCell}`, children: params.subProjectStatus })
                : _jsx(Typography.Link, { onClick: (e) => {
                        handleOpenSubProjectHoldReasonInfoModal(params.lstOfHoldReason);
                        setHoldReasonTitleKeyword((params.subProjectStatusId == 4004 ? 'Stop' : 'On Hold') + ' - Sub Project Status');
                    }, children: params.subProjectStatus }))
        },
        {
            title: 'Risk Status',
            dataIndex: 'riskStatus',
            key: 'riskStatus',
            render: (text, params) => (params.riskStatusId == 1
                ? _jsx(Typography.Text, { color: `${params.styleCell}`, children: "Project On Schedule" })
                : (params.riskStatusId == 2
                    &&
                        _jsx(Typography.Link, { onClick: (e) => handleOpenSubProjectRiskStatusInfoModal(params.workOrderId), children: "Project On Risk" })))
        },
        {
            title: 'Product Model',
            dataIndex: 'productModel',
            key: 'productModel',
        },
        {
            title: 'Brand OEM',
            dataIndex: 'brandName',
            key: 'brandName',
            render: (text, params) => (!params.isSingleCertificate
                ? _jsx(Typography.Text, { color: `${params.styleCell}`, children: params.brandName })
                : _jsx(Typography.Link, { onClick: (e) => handleOpenProductFamilyModal(), children: params.brandName }))
        },
        {
            title: 'Recommended Timeline',
            dataIndex: 'recommendedTimeline',
            key: 'recommendedTimeline',
            render: (text, params) => {
                const recommendedTimelineItems = [];
                if (params.recommendedStartDate) {
                    recommendedTimelineItems.push({
                        key: '1',
                        label: 'Recommended Start Date',
                        children: formatDisplayDate(params.recommendedStartDate),
                    });
                }
                if (params.deadline) {
                    recommendedTimelineItems.push({
                        key: '2',
                        label: 'Deadline',
                        children: formatDisplayDate(params.deadline),
                    });
                }
                if (params.prevCertificateExpDate) {
                    recommendedTimelineItems.push({
                        key: '3',
                        label: 'Previous Certificate Expiration Date',
                        children: formatDisplayDate(params.prevCertificateExpDate),
                    });
                }
                return _jsx(Descriptions, { size: "small", style: { width: '260px' }, items: recommendedTimelineItems, column: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1 } });
            }
        },
        {
            title: 'Actual Timeline',
            dataIndex: 'actualTimeline',
            key: 'actualTimeline',
            render: (text, params) => {
                const actualTimelineItems = [];
                if (params.actualDecisionDate) {
                    actualTimelineItems.push({
                        key: '11',
                        label: 'Actual Decision Date',
                        children: formatDisplayDate(params.actualDecisionDate),
                    });
                }
                if (params.actualStartDate) {
                    actualTimelineItems.push({
                        key: '22',
                        label: 'Actual Start Date',
                        children: formatDisplayDate(params.actualStartDate),
                    });
                }
                if (params.actualCompletionDate) {
                    actualTimelineItems.push({
                        key: '33',
                        label: 'Actual Completion Date',
                        children: formatDisplayDate(params.actualCompletionDate),
                    });
                }
                return _jsx(Descriptions, { size: "small", style: { width: '260px' }, items: actualTimelineItems, column: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1 } });
            }
        },
        {
            title: 'Document Completion %',
            dataIndex: 'documentCompletion',
            key: 'documentCompletion',
            render: (text, params) => { var _a; return (_a = params === null || params === void 0 ? void 0 : params.documentCompletionPercentage) === null || _a === void 0 ? void 0 : _a.toFixed(2); }
        },
    ];
    useEffect(() => {
        const listWithId = lstWorkOrder === null || lstWorkOrder === void 0 ? void 0 : lstWorkOrder.map((data, index) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
            return {
                key: index,
                workOrderId: data === null || data === void 0 ? void 0 : data.strWorkOrderId,
                certificate: (_a = data === null || data === void 0 ? void 0 : data.objTblService) === null || _a === void 0 ? void 0 : _a.strServiceName,
                country: (_c = (_b = data === null || data === void 0 ? void 0 : data.objTblService) === null || _b === void 0 ? void 0 : _b.objLuCountry) === null || _c === void 0 ? void 0 : _c.strLongDesc,
                subProjectStatus: (_d = data === null || data === void 0 ? void 0 : data.objLuWorkOrderStatus) === null || _d === void 0 ? void 0 : _d.strLongDesc,
                subProjectStatusId: (_e = data === null || data === void 0 ? void 0 : data.objLuWorkOrderStatus) === null || _e === void 0 ? void 0 : _e.intId,
                riskStatus: data === null || data === void 0 ? void 0 : data.strRiskStatus,
                riskStatusId: data === null || data === void 0 ? void 0 : data.intRiskStatus,
                productModel: !(data === null || data === void 0 ? void 0 : data.boolSingleCertificate) ? (_f = data === null || data === void 0 ? void 0 : data.objEEMaster) === null || _f === void 0 ? void 0 : _f.strSeriesModel : (_g = data === null || data === void 0 ? void 0 : data.objEEMaster) === null || _g === void 0 ? void 0 : _g.strPrimaryModel,
                brandName: (_j = (_h = data === null || data === void 0 ? void 0 : data.objEEMaster) === null || _h === void 0 ? void 0 : _h.objBrandName) === null || _j === void 0 ? void 0 : _j.strLongDesc,
                recommendedStartDate: data === null || data === void 0 ? void 0 : data.dtPlannedStartDate,
                deadline: data === null || data === void 0 ? void 0 : data.dtExpComplDate,
                prevCertificateExpDate: data === null || data === void 0 ? void 0 : data.dtPrevCertDate,
                actualDecisionDate: data === null || data === void 0 ? void 0 : data.dtActualDecisionDate,
                actualStartDate: data === null || data === void 0 ? void 0 : data.dtStartDate,
                actualCompletionDate: data === null || data === void 0 ? void 0 : data.dtCompletionDate,
                documentCompletionPercentage: (_k = data === null || data === void 0 ? void 0 : data.objEEDocument) === null || _k === void 0 ? void 0 : _k.dbWoDocsCompCount,
                isSingleCertificate: data === null || data === void 0 ? void 0 : data.boolSingleCertificate,
                lstOfProductFamily: (_l = data === null || data === void 0 ? void 0 : data.objEEMaster) === null || _l === void 0 ? void 0 : _l.lstProductFamily,
                lstOfHoldReason: data === null || data === void 0 ? void 0 : data.objLuStopReason,
                lstOfVendorCertificates: data === null || data === void 0 ? void 0 : data.lstVenCertificates,
                isCertificateAvailable: data === null || data === void 0 ? void 0 : data.boolWoCertificateAvail,
                styleCell: ((_m = data === null || data === void 0 ? void 0 : data.objLuWorkOrderStatus) === null || _m === void 0 ? void 0 : _m.strShortDesc) ? (_o = data === null || data === void 0 ? void 0 : data.objLuWorkOrderStatus) === null || _o === void 0 ? void 0 : _o.strShortDesc : ((data === null || data === void 0 ? void 0 : data.intRiskStatus) == 2 ? 'rgb(255, 1, 1)' : 'rgba(0, 0, 0, 0.87)'),
                //rowData.rowColor = data?.intRiskStatus == 2 ? '#ff0101' : '';
            };
        });
        setTableData(listWithId);
    }, [lstWorkOrder]);
    return (_jsxs(_Fragment, { children: [_jsx(SubProjectHoldReasonInfo, { isModalOpen: isModalOpen, handleOk: handleOk, handleCancel: handleCancel, modalContent: listOfHoldReason, title: holdReasonTitleKeyword }), _jsx(SubProjectRiskStatusInfoModal, { isModalOpen: isModalOpenRiskStatus, handleOk: handleOkRS, handleCancel: handleCancelRS, modalContent: listOfRiskStatus, title: '' }), _jsx(SubProjectProductFamilyModal, { isModalOpen: isModalOpenProductFamily, handleOk: handleOkPF, handleCancel: handleCancelPF, modalContent: listOfProductFamily, title: '' }), _jsx(SubProjectCertificateModal, { isModalOpen: isModalOpenCertificate, handleOk: handleOkCertificate, handleCancel: handleCancelCertificate, modalContent: listOfVendorCertificates, title: woCertificatesTitleKeyword }), _jsx(Card, { style: { borderRadius: '0px' }, title: 'Sub Projects', extra: _jsx(Alert, { message: "Note: Actual Start Date will be populated on submission of all documents", type: "info", showIcon: true }), children: _jsx(Table, { scroll: {
                        x: 1400
                    }, columns: columns, dataSource: tableData, size: 'small', style: { borderRadius: '0px' } }) })] }));
};
export default SubProjectDataTable;
